import { z } from 'zod';
// =============================================================================
// CONDITIONS SCHEMAS
// =============================================================================
export const ConditionTypeSchema = z.enum(['discount-code', 'product-in-cart']);
// Future: 'cart-total', 'customer-tag', ...
export const ZDiscountCodeConditionSchema = z.object({
    operator: z.literal('eq'),
    type: z.literal('discount-code'),
    value: z.string().trim().min(1),
});
export const ZProductInCartConditionSchema = z.object({
    operator: z.literal('eq'),
    type: z.literal('product-in-cart'),
    value: z.string().trim().min(1, 'Product ID is required'),
});
export const ExtensionConditionSchema = z.union([
    ZDiscountCodeConditionSchema,
    ZProductInCartConditionSchema,
]);
// =============================================================================
// TRIGGER-BASED CONDITION MAPPING
// =============================================================================
/**
 * Schema that validates conditions based on trigger type
 */
export function ConditionsForTriggerSchema(trigger) {
    if (trigger === 'on-discount-application') {
        return z.array(ZDiscountCodeConditionSchema);
    }
    if (trigger === 'on-checkout-initiation') {
        return z.array(ZProductInCartConditionSchema);
    }
    return z.never();
}
/**
 * Extension conditions schema with trigger validation
 */
export function ExtensionConditionsSchema(trigger) {
    return z.object({
        strategy: z.enum(['all', 'any']),
        conditions: trigger ? ConditionsForTriggerSchema(trigger) : z.array(ExtensionConditionSchema),
    });
}
// Generic schema for when trigger is not known at compile time
export const GenericExtensionConditionsSchema = z
    .object({
    strategy: z.enum(['all', 'any']),
    conditions: z.array(ExtensionConditionSchema),
})
    .strict();
//# sourceMappingURL=conditions.js.map